<template>
  <div class="changePwdWrapper">
    <p class="changepwdTitle">使用状态</p>
    <el-radio-group v-model="pwdstatus" @change="handleRedio">
      <el-radio :label="0">我记得原密码</el-radio>
      <el-radio :label="1">我不记得原密码</el-radio>
    </el-radio-group>
    <div class="knowPdw" v-if="pwdstatus == 0">
      <el-form
        ref="knowpwdForm"
        :rules="knowpwdFormRules"
        :model="knowpwdForm"
        label-position="left"
        label-width="110px"
      >
        <el-form-item label="旧密码：" prop="oldPassword">
          <el-input v-model="knowpwdForm.oldPassword" style="max-width: 290px" show-password></el-input>
        </el-form-item>
        <el-form-item label="新密码：" prop="password">
          <el-input v-model="knowpwdForm.password" style="max-width: 290px" show-password></el-input>
        </el-form-item>
      </el-form>
      <el-button type="primary" style="margin-top: 156px; margin-left: 110px" @click="handleKnowpwdSave"
        >保存</el-button
      >
    </div>
    <div class="unknowPdw" v-if="pwdstatus == 1">
      <el-form
        ref="unknowpwdForm"
        :rules="unknowpwdFormRules"
        :model="unknowpwdForm"
        label-position="left"
        label-width="110px"
      >
        <el-form-item label="手机号：">
          <span>{{ phoneNo }}</span>
        </el-form-item>
        <el-form-item label="验证码：" prop="smsCode">
          <!-- 解决账号密码填充 -->
          <el-input type="password" style="position: fixed; bottom: -9999px" placeholder="请输入"></el-input>
          <el-input v-model="unknowpwdForm.smsCode" style="width: 143px" placeholder="请输入验证码"></el-input>
          <el-button type="primary" style="margin-left: 10px; width: 136px" v-if="msgtime == 60" @click="getsmscode"
            >获取验证码</el-button
          >
          <el-button disabled type="primary" style="margin-left: 10px" v-if="msgtime < 60"
            >{{ msgtime }}s后重新获取</el-button
          >
        </el-form-item>
        <el-form-item label="新密码：" prop="password">
          <!-- 解决账号密码填充 -->
          <el-input type="password" style="position: fixed; bottom: -9999px" placeholder="请输入"></el-input>
          <el-input v-model="unknowpwdForm.password" style="max-width: 290px" show-password></el-input>
        </el-form-item>
      </el-form>
      <el-button type="primary" style="margin-top: 156px; margin-left: 110px" @click="handleUnknowpwdSave"
        >保存</el-button
      >
    </div>
  </div>
</template>
<script>
import { userSafetyInfoupdatepassword, userSafetyInfosendsmsCode } from '@/api/userCenter';
import { encrypt, decrypt } from '@/utils/rsaEncrypt'; //加密，解密
import qs from 'qs';
export default {
  props: {
    phoneNo: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      pwdstatus: null,
      knowpwdForm: {
        userId: '',
        oldPassword: '',
        password: '',
      },
      knowpwdFormRules: {
        oldPassword: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
        password: [{ required: true, message: '请输入新密码', trigger: 'blur' },   { validator: this.passwordVaild, trigger: 'blur' },],
      },
      unknowpwdForm: {
        smsCode: '',
        password: '',
      },
      unknowpwdFormRules: {
        smsCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        password: [{ required: true, message: '请输入新密码', trigger: 'blur' },{ validator: this.passwordVaild, trigger: 'blur' }],
      },
      msgtime: 60,
    };
  },
  methods: {
    handleKnowpwdSave() {
      this.$refs.knowpwdForm.validate((valid) => {
        if (valid) {
          // 新旧密码不能一致
          if (this.knowpwdForm.oldPassword == this.knowpwdForm.password) {
            this.$message.error('新密码不能和旧密码相同');
            return;
          }
          let params = {
            userId: this.$store.state.user.user.userId,
            updateType: 1,
            oldPassword: encrypt(this.knowpwdForm.oldPassword),
            password: encrypt(this.knowpwdForm.password),
          };
          userSafetyInfoupdatepassword(params).then((res) => {
            if (res.resultType == 1) {
              this.$message.success(res.resp_msg);
            } else if (res.resultType == 2) {
              this.$message.error(res.resp_msg);
            }
            this.knowpwdForm.oldPassword = '';
            this.knowpwdForm.password = '';
          });
        }
      });
    },
    getsmscode() {
      let that = this;
      userSafetyInfosendsmsCode(
        qs.stringify({
          userId: this.$store.state.user.user.userId,
        })
      ).then((res) => {
        if (res) {
          let time = 60;
          let t1 = setInterval(function () {
            time--;
            that.msgtime = time;
            if (time <= 0) {
              clearInterval(t1);
              that.msgtime = 60;
            }
          }, 1000);
        }
      });
    },
    handleUnknowpwdSave() {
      this.$refs.unknowpwdForm.validate((valid) => {
        if (valid) {
          let params = {
            userId: this.$store.state.user.user.userId,
            updateType: 2,
            password: encrypt(this.unknowpwdForm.password),
            smsCode: this.unknowpwdForm.smsCode,
          };
          userSafetyInfoupdatepassword(params).then((res) => {
            if (res.resultType == 1) {
              this.$message.success(res.resp_msg);
            } else if (res.resultType == 2) {
              this.$message.error(res.resp_msg);
            }
            this.unknowpwdForm.smsCode = '';
            this.unknowpwdForm.password = '';
          });
        }
      });
    },
    handleRedio() {
      this.unknowpwdForm.smsCode = '';
      this.$refs.knowpwdForm && this.$refs.knowpwdForm.clearValidate();
      this.$refs.unknowpwdForm && this.$refs.unknowpwdForm.clearValidate();
    },
    passwordVaild(rule, value, callback){
        if(value.length<6){
          callback(new Error('密码长度必须大于6位'));
        }else{
        callback();
        }
    }
  },
};
</script>
<style lang="less" scoped>
.changePwdWrapper {
  margin-top: 38px;
  .changepwdTitle {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #55555a;
    line-height: 20px;
    margin-bottom: 20px;
  }
  .knowPdw {
    margin-top: 60px;
  }
  .unknowPdw {
    margin-top: 60px;
  }
}
</style>